module.exports = __webpack_public_path__ + "img/cancelIcon.e44b6242.svg";